import * as app from './app';
import * as auth from './auth';
export const localStorageHandlers = { auth, app };
